export const staticAssets = {
    favicon: '/anotoys.ico',
} 